module.exports = __webpack_public_path__ + "static/chart-schiff.e42ab91e.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/chart-schiff.jpg
// module id = 1345
// module chunks = 4